  document.addEventListener("DOMContentLoaded", function () {
    var faqs = document.querySelectorAll(".im-faq-item");

    for (var i = 0; i < faqs.length; i++) {
      (function (faq) {
        var question = faq.querySelector(".im-faq-question");
        question.addEventListener("click", function () {
          // toggle this one
          faq.classList.toggle("active");

          // close others
          for (var j = 0; j < faqs.length; j++) {
            if (faqs[j] !== faq) {
              faqs[j].classList.remove("active");
            }
          }
        });
      })(faqs[i]);
    }
  });
